export default function Grain() {
  return (
    <>
      <svg
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[60] mix-blend-overlay"
        style={{ opacity: 0.025 }}
        width="100%"
        height="100%"
      >
        <filter id="wam-noise">
          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" stitchTiles="stitch" />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#wam-noise)" />
      </svg>
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[55] wam-grid-bg opacity-70"
      />
    </>
  );
}
